export default __webpack_public_path__ + "static/media/usa-flag.dcbc42c5.png";